import React, {useState} from 'react';
import Navbar from './Navbar';
import '../App.css';
import './ContactContent.css';
import Container from '@material-ui/core/Container';
import mailData from '../data/mailData.js';

function ContactContent() {
    return (
        <>
        <div className="tech-container main-container" id="contact-box">
            <title>Job Readiness - Contact</title>
            <h1 className="sr-only" tabIndex={0}>Job Readiness - Contact</h1>
            <img src="/images/contact-us-banner.jpg" className="banner-img" alt=''/>
            <Navbar/> 
        </div>
        <Container className='contact-box' id="main">
            <h2>For learning related queries reach out to: <br/>
            <span><a href={`mailto:${mailData.lttjobreadiness}`}>L-TT.JobReadiness</a></span>
            </h2>
        </Container>

        </>
    )
}

export default ContactContent;

